import { loadState, getSelectedDate } from "./persistState";

const persistState = loadState() || {};

// This object describes the initial state of the application
export const initialState = {
  currentFoodCourt: null,
  currentFoodCourtDetails: persistState.currentFoodCourtDetails,
  currentRestaurantDetails: {
    restextras: persistState.restaurantDetails || {},
    loginextras: persistState.userDetails || {},
    paymentoptions: persistState.paymentDetails || {},
    FoodNa: persistState.FoodNa || [],
    acceptsodexo: persistState.acceptsodexo || false
  },
  immutableMenuList: {},
  immutableSubMenu: persistState.immutableSubMenu || {},
  menuList: {},
  cartItems: persistState.cartItems || {},
  foodCourtsList: [],
  foodCourtSettings: {},
  userDetails: persistState.userDetails || {},
  searchText: "",
  immutableFilterList: [],
  currentSession: "",
  selectedDate: getSelectedDate(),
  filters: persistState.filters || [],
  errorMessage: "",
  successOrderID: {},
  snackbarMessage: "",
  paymentOptions: persistState.paymentDetails || {},
  firebaseDetails: {},
  addToHomeScreen: false,
  restaurantsList: persistState.restaurantsList || {},
  multiRestaurantDetails: persistState.multiRestaurantDetails || {},
  immutableMultiSubMenu: persistState.immutableMultiSubMenu || {},
  tempCart: {},
  foodNRecURLS: {},
  firebaseStaticData: {},
  forceTrigger: true,
  immutableAllergens: [],
  allergens: [],
  cafePass: persistState.cafePass || { cafePassList: [], activePass: {} },
  slotDisplay: persistState.slotDisplay,
  preorderData: persistState.preorderData || {},
  sessionsData: persistState.sessionsData || {}
};

//state retured after "PURGE_EVERYTHING" action
export const resetState = {
  currentFoodCourt: null,
  currentFoodCourtDetails: null,
  currentRestaurantDetails: null,
  immutableMenuList: {},
  immutableSubMenu: {},
  menuList: {},
  cartItems: {},
  foodCourtsList: [],
  foodCourtSettings: {},
  userDetails: {},
  searchText: "",
  immutableFilterList: [],
  currentSession: "",
  selectedDate: "",
  filters: [],
  errorMessage: "",
  successOrderID: {},
  snackbarMessage: "",
  paymentOptions: null,
  firebaseDetails: {},
  addToHomeScreen: false,
  restaurantsList: {},
  multiRestaurantDetails: {},
  immutableMultiSubMenu: {},
  tempCart: {},
  firebaseStaticData: persistState.firebaseStaticData || {}, //persist when "PURGE_EVERYTHING" action
  forceTrigger: true,
  immutableAllergens: [],
  allergens: [],
  cafePass: { cafePassList: [], activePass: {} },
  slotDisplay: {},
  preorderData: {},
  sessionsData: {}
};



// WEBPACK FOOTER //
// ./src/store/initialState.js